module.exports = __webpack_public_path__ + "static/media/20.7f40a054.jpg";